<template>
    <div>
        <confirm ref="confirm"></confirm>        
        <list :label="$t('keywords google')" v-bind:refresh="this.refresh" table='keywordswebsearch' v-on:childMessage="onMessageFromListReceived" initialSortBy="keyword" :initialSortDesc="false"></list>
        <v-dialog v-bind:value="showFileDialog" v-bind:persistent="true" max-width="600">
            <v-card>
                <v-card-title>
                    {{$t('upload file')}}
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon dense right
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            >mdi-information-outline</v-icon>
                        </template>
                        <span>{{$t("import websearch")}}</span>
                    </v-tooltip>
                </v-card-title>
                <v-card-text>
                    <v-file-input show-size v-model=file :label="$t('select file')"/>
                    <v-select v-model="folder" label="Typ" :items=getFolders()></v-select>
                    <v-checkbox v-model="overwrite" :label="$t('overwrite file')"></v-checkbox>
                    <v-select v-if="isAdmin()" v-model="customerId" :label="$t('customer')" :items=getCustomers() item-text="customername" item-value="id"></v-select>
                    <v-chip outlined color="primary" v-if='this.text!=""'>
                        {{text}}
                    </v-chip>
                </v-card-text>
                <v-card-actions>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=submitFile><v-icon dense left>mdi-cloud-upload-outline</v-icon>{{$t('upload')}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=cancel()><v-icon dense left>mdi-cancel</v-icon>{{$t('cancel')}}</v-btn>                    
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-bind:value="showDialog" v-bind:persistent="true" max-width="600">
            <v-card>
                <v-card-title>
                    {{title}}
                </v-card-title>
                <v-card-text>
                    <div v-for="field in fields" v-bind:key="field.value">
                        <div v-if="field.value !== 'id' && field.value !== 'actions'">
                            <v-text-field v-if="field.value != 'customername'" v-model="field.model" v-bind:label="field.text"/>
                            <v-select v-else v-model="field.model" v-bind:label="field.text" :items=getCustomers() item-text="customername" item-value="id"></v-select>
                        </div>
                    </div>
                    <v-chip outlined color="primary" v-if='this.text!=""'>
                        {{text}}
                    </v-chip>
                </v-card-text>
                <v-card-actions>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=save()><v-icon dense left>mdi-content-save-outline</v-icon>{{$t('save')}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=cancel()><v-icon dense left>mdi-cancel</v-icon>{{$t('cancel')}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=uploadFile()><v-icon dense left>mdi-file-upload-outline</v-icon>{{$t('upload file')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import List from "@/components/List"
import Api from "@/Api"
import { Utils } from "@/Utils"
import Confirm from "@/components/Confirm";

export default {
    components:
    {
        List, Confirm
    },

    data()
    {
        return {
            customerId: "",
            showFileDialog: "",
            file: null,
            showDialog: "",
            fields: [],
            refresh: 0,
            title: "",
            text: "",
            folder: "Allgemein",
            overwrite: false
        };
    },

    props: [],

    mixins: [Utils],

    methods:
    {
        onMessageFromListReceived (message)
        {
            this.text = "";
            if (message.cmd === "newRecord")
            {
                this.title = this.$t("new keyword");
                this.fields = JSON.parse(JSON.stringify(message.header));
                this.fields.shift(); //remove ID

                for (let field of this.fields)
                {
                    field.model = "";
                }
                this.showDialog = true;
            }
            else if (message.cmd === "updRecord")
            {
                this.title = this.$t("update keyword");
                this.fields = JSON.parse(JSON.stringify(message.header));
                for (let field of this.fields)
                {
                    if (field.value === "customername")
                    {
                        const customerId = this.getCustomerId(message.item[field.value]);
                        if (customerId > 0)
                            field.model = customerId;
                        else
                            field.model = ""
                    }
                    else
                        field.model = message.item[field.value]
                }

                this.showDialog = true;
            }
            else if (message.cmd === "delRecord")
            {
                const id = message.item["id"];
                const self = this;
                Api.deleteRecord("keywordswebsearch", id).then(function(result)
                {
                    if (result.status === 200)
                    {
                        self.refresh += 1;
                    }
                    else
                        alert (self.$t('action not possible'));

                })
                .catch((e) =>
                {
                    alert (self.$t('action not possible'));
                });
            }
        },
        cancel ()
        {
            this.customerId = "";
            this.showFileDialog = "";
            this.showDialog = "";
            this.fields = [];
            this.text = "";
            this.file = null;
        },
        save ()
        {
            const self = this;
            this.text = "";
            for (let field of this.fields)
            {
                if (field.text === this.$t("keyword"))
                    if (field.model.trim() == "")
                    {
                        this.text = this.$t("enter keyword");
                        return;
                    }
                    else
                        break;
            }
            Api.saveRecord("keywordswebsearch", this.fields).then(function(result)
            {
                if (result.status === 200)
                {
                    self.showDialog = "";
                    self.refresh += 1;
                }
                else
                    self.text = self.$t('action not possible');

            })
            .catch((e) =>
            {
                if (e.response.status === 409)
                    self.text = self.$t('already exists');
                else
                    self.text = self.$t('action not possible');
            });
        },
        uploadFile ()
        {
            this.cancel();
            this.showFileDialog = true;
        },
        submitFile()
        {
            if (!this.file)
            {
                this.text = this.$t('select file');
                return;
            }
            const self = this;
            this.text = "";
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('type', "WEBSEARCH");
            formData.append('folder', this.folder);
            formData.append('overwrite', this.overwrite);
            if (this.isAdmin())
                formData.append('customerId', this.customerId)

            Api.uploadFile(formData)
            .then(function(e)
            {
                if (e.data.result == "processed")
                {
                    self.$refs.confirm.open(self.$t("file processed"), {confirm:false}).then((confirm) =>
                    {
                        self.cancel();
                    });
                }
                else if (e.data.result == "error")
                {
                    self.text = self.$t('processing not possible');
                    if (e.data.details)
                        self.text += " " + e.data.details;
                }
                else
                    self.cancel();

                self.refresh++;
            })
            .catch(function(e)
            {
                if (e.response.status === 409)
                    self.text = self.$t('already exists');
                else
                    self.text = self.$t('action not possible');
            });
        },
    }
};
</script>